<template>
    <v-layout class="row wrap">
        <v-flex xs12 v-if="loading">
            <v-progress-linear :indeterminate="true"></v-progress-linear>
        </v-flex>
        <v-flex xs12 v-if="!loading">
            <v-card flat >
                <v-card-title class="primary white--text headline">
                    {{'Report'|translate}}
                    <v-spacer></v-spacer>
                    <date-range-selector class="white--text" v-model="dateRange"  @change="handleDateChange()"></date-range-selector>
                    <v-btn class="white--text noprint"
                            flat
                            @click="printReport()"
                    >
                        <v-icon class="mr-2">fa-print</v-icon>
                        {{'Print'|translate}}
                    </v-btn>
                </v-card-title>
                <v-layout row wrap>
                    <v-flex xs12 md6>
                        <vue-plotly v-if="topCost" disable-responsive :data="topCost.data"
                                    :layout="topCost.layout" :options="{}"/>
                    </v-flex>
                    <v-flex xs12 md6>
                        <vue-plotly v-if="topDuration" disable-responsive :data="topDuration.data"
                                    :layout="topDuration.layout" :options="{}"/>
                    </v-flex>
                    <v-flex xs12>
                        <div class="pr-5 pl-5 mt-5"><v-textarea solo box flat auto-grow v-model="comment1"></v-textarea></div>
                    </v-flex>
                    <v-flex xs12>
                        <v-card-title class="accent white--text subheading mt-3">
                            {{'FDD Faults'|translate}}
                        </v-card-title>
                    </v-flex>
                    <v-flex xs12 v-for="fault in topAHUDetails" v-bind:key="fault.rule_id" class="pa-3">
                        <v-divider></v-divider>
                        <h3>{{fault.title}}</h3>
                        <v-divider class="mb-4"></v-divider>
                        <p><strong>{{'Equipments'|translate}} : </strong>{{fault.equipmentNames.join(', ')}}</p>
                        <p><strong>{{'Description'|translate}} : </strong>{{fault.desc}}</p>
                        <p v-if="fault.recommended_actions"><strong>{{'Recommended actions'|translate}} : </strong></p>
                        <ul v-if="fault.recommended_actions">
                            <li v-for="i in fault.recommended_actions.split('\n')">{{i}}</li>
                        </ul>
                        <fault-comparison-plot :equipment-names="fault.equipmentNames"
                                               :issue="fault.title"
                                               :fault-desc="fault.desc"
                                               :relevant-variables="fault.relevant_variables"
                                               :color="severityColors[fault.severity]"
                                               :date-range="dateRange"
                        ></fault-comparison-plot>
                    </v-flex>

<!--                    <v-flex xs12>-->
<!--                        <v-card-title class="accent white&#45;&#45;text subheading mt-3">-->
<!--                            Machine Learning Faults-->
<!--                        </v-card-title>-->
<!--                    </v-flex>-->
<!--                    <v-flex xs12 v-for="fault in topAHuAnomalyDetail" v-bind:key="fault.notification_id" class="pa-3">-->
<!--                        <v-divider></v-divider>-->
<!--                        <h3>{{fault.title}}</h3>-->
<!--                        <v-divider class="mb-4"></v-divider>-->
<!--                        <p><strong>Equipments : </strong>{{fault.equipmentNames.join(', ')}}</p>-->
<!--                        <p><strong>Description : </strong>{{fault.description}}</p>-->
<!--                        <p v-if="fault.recommended_actions"><strong>Recommended actions : </strong></p>-->
<!--                        <ul v-if="fault.recommended_actions">-->
<!--                            <li v-for="i in fault.recommended_actions.split('\n')">{{i}}</li>-->
<!--                        </ul>-->
<!--                        <anomaly-summary-base v-for="equip in fault.equipmentNames" :range="dateRange" :equipment="equip"></anomaly-summary-base>-->
<!--                    </v-flex>-->

                </v-layout>
            </v-card>
        </v-flex>
    </v-layout>
</template>

<script>

    import moment from 'moment'
    import {getRule,getNotification,getIssueSummary} from '@/helper'
    import DateRangeSelector from "../components/DateRangeSelector";
    import FaultComparisonPlot from "../components/FaultComparisonPlot";
    import AnomalySummaryBase from "../components/anomaly/AnomalySummaryBase";
    import printer from "../components/mixins/printer";
    import VuePlotly from "../components/VuePlotly";

    export default {
        name: 'FaultsReport',
        components: {DateRangeSelector,FaultComparisonPlot,AnomalySummaryBase,VuePlotly},
        mixins:[printer],
        computed: {
            facility_name() {
                return this.$store.state.pointsListStore.pointsList.facility_name
            },
        },
        data () {
            return {
                menu:false,
                baseDate:  moment().subtract(31, "days"),
                endDate:  moment().subtract(1, "days"),
                dateRange:  {start:moment().subtract(31, "days").format("YYYY-MM-DD"),end:moment().subtract(1, "days").format("YYYY-MM-DD")},
                refinedRange:  null,
                loading:true,
                severityColors:{
                    critical:'rgb(148, 103, 189)',
                    low:'rgb(188, 189, 34)',
                    medium:'rgb(255, 127, 14)',
                    high:'rgb(214, 39, 40)',
                },
                chillers:[],
                pumps:[],
                ahus:[],
                topPumpDetails:[],
                topAHUDetails:[],
                topAHuAnomalyDetail:[],
                topCost:null,
                topDuration:null,
                topPumpAnomalyDetail:[],
                faults:[],
                rules:[],
                comment1:"Analysis",
                topAHU:null,
                topAHUAnomaly:null,
                topPumpAnomaly:null,
                topPump:null,
            }
        },

        methods:{
            printReport(){
                this.printPage()
            },
            jumpToNotification(data,facet) {
              let output = {
                        path: '/notification-breakdown',
                  query:{
                      rangeStart: this.baseDate.startOf('day').format('YYYY-MM-DD HH:mm:ss'),
                      rangeEnd: this.endDate.endOf('day').format('YYYY-MM-DD HH:mm:ss'),
                  }
                    }
                output.query[facet]=data.points[0].label
              this.$router.push(output)
            },
            jumpToLink(item) {
                let output = null;
                if (item.title.substring(0,7) === "Anomaly") {
                    output = {
                        path: '/modelsummary',
                        query: {
                            rangeStart: item.to.query.rangeStart,
                            rangeEnd: item.to.query.rangeEnd,
                            equipment: item.equipment_name
                        }
                    }
                } else if (item.topic==="equipment health"){
                    output = {
                        path: '/equipment-health',
                        query: {
                            equipment: item.equip,
                        }
                    }
                }else {
                    output = {
                        path: '/fault-analysis',
                        query: {
                            relevantVariables: item.to.query.variableX,
                            faultName: item.title,
                            faultDesc: item.description,
                            rangeStart: item.to.query.rangeStart,
                            rangeEnd: item.to.query.rangeEnd,
                            equipmentName: item.equipment_name
                        }
                    }
                }

                this.$router.push(output)
            },
            addArrays(ar1, ar2){
                let ar3 = [];
                for(let i in ar1)
                    if(!ar2[i]){
                        ar3.push(ar1[i]);
                    } else {
                        ar3.push(ar1[i] + ar2[i]);
                    }
                return ar3;
            },
            handleDateChange(){
                this.baseDate = moment(this.dateRange.start)
                this.endDate = moment(this.dateRange.end)
                this.getData()
            },
            getFaultDetails(title){
                let myRule=null
                for(let rule of this.rules){
                    if(rule.title===title){
                        myRule={...rule}
                        break
                    }
                }
                if(myRule){
                    let equips=[]
                    for (let fault of this.faults){
                        if(fault.title===title){
                            equips.push(fault.equipment_name)
                        }
                    }
                    myRule.equipmentNames=[...new Set(equips)]
                }
                return(myRule)
            },
            getData(){
                let me=this;
                me.loading=true
                me.chillers=[]
                me.pumps=[]
                me.ahus=[]
                let currentRange=[me.baseDate.startOf('day').format('YYYY-MM-DD HH:mm:ss'),me.endDate.endOf('day').format('YYYY-MM-DD HH:mm:ss')]
                me.refinedRange={
                    start:currentRange[0],
                    end:currentRange[1],
                }
                getNotification({
                    facility_name: this.$store.state.pointsListStore.pointsList.facility_name,
                    ignore_acknowledged:true,
                    date_range:currentRange,
                }).then(function(notifResult) {
                    let rangeFaults = notifResult.result.filter(function(x) {
                        return (!x.acknowledged&&!(x.topic==="anomaly"||x.title.toLowerCase().startsWith("anomaly"))&&(x.severity.toLowerCase()==="critical"||x.severity.toLowerCase()==="high"||x.severity.toLowerCase()==="medium"))
                    })
                    let cpFaultSeverity = { }
                    let cpFaultTopic = { }
                    for (let fault of rangeFaults){
                        if(!cpFaultSeverity[fault.severity]){
                            cpFaultSeverity[fault.severity]=1
                        } else {
                            cpFaultSeverity[fault.severity]=cpFaultSeverity[fault.severity]+1
                        }
                        if(!cpFaultTopic[fault.topic]){
                            cpFaultTopic[fault.topic]=1
                        } else {
                            cpFaultTopic[fault.topic]=cpFaultTopic[fault.topic]+1
                        }
                    }
                    let faultEquip = { }
                    for (let fault of rangeFaults){
                        if(!faultEquip[fault.equipment_type]){
                            faultEquip[fault.equipment_type]=1
                        } else {
                            faultEquip[fault.equipment_type]=faultEquip[fault.equipment_type]+1
                        }
                    }
                    me.faults=rangeFaults.sort((a, b) => (a.end_date < b.end_date) ? 1 : -1);
                    let fddRepData=[]
                    let faultsByType={
                        'Pumps':rangeFaults.filter(x=>x.equipment_type=="SCP"),
                        'AHUs':rangeFaults.filter(x=>x.equipment_type&&x.equipment_type.toLowerCase().startsWith("ahu")),
                    }
                    for (let faultType in faultsByType){
                        let part={
                            x:[],
                            y:[],
                            name: me.$options.filters.translate(faultType),
                            type: 'bar',
                            orientation: 'h'
                        }
                        for (let severity in cpFaultSeverity){
                            part.y.push(severity)
                            part.x.push(faultsByType[faultType].filter(x=>x.severity===severity).length)
                        }
                        fddRepData.push(part)
                    }

                    let AHUNAFaults=rangeFaults.filter(x=>x.topic!=="anomaly"&&x.severity!=="low"&&!x.title.toLowerCase().startsWith("anomaly"))
                    let AHUAnomaly=rangeFaults.filter(x=>(x.topic=="anomaly"||x.title.toLowerCase().startsWith("anomaly")))
                    let ahuBearer={}
                    for (let fault of AHUNAFaults){
                        if(!ahuBearer[fault.title]){
                            ahuBearer[fault.title]=1
                        } else {
                            ahuBearer[fault.title]+=1
                        }
                    }
                    let sortedAHU = Object.keys(ahuBearer).sort(function(a,b){return ahuBearer[b]-ahuBearer[a]})
                    let top5AHU=sortedAHU;
                    let top5AHUScores=[]
                    let topAHUDetails=[];
                    for(let top of top5AHU){
                        top5AHUScores.push(ahuBearer[top])
                        let detail=me.getFaultDetails(top)
                        if(detail){
                            topAHUDetails.push(detail)
                        }

                    }
                    me.topAHUDetails=topAHUDetails
                    let bearer={}
                    for (let fault of AHUAnomaly){
                        if(!bearer[fault.title]){
                            bearer[fault.title]=1
                        } else {
                            bearer[fault.title]+=1
                        }
                    }
                    let sorted = Object.keys(bearer).sort(function(a,b){return bearer[b]-bearer[a]})
                    let topAHuAnomaly=sorted;
                    let topAHuAnomalyScores=[]
                    let topAHuAnomalyDetail=[];
                    for(let top of topAHuAnomaly){
                        topAHuAnomalyScores.push(bearer[top])
                        let detail = null
                        for(let fault of me.faults){
                            if(fault.title===top){
                                detail=fault
                                break
                            }
                        }
                        if(detail){
                            detail.equipmentNames=[...new Set(me.faults.filter(fault=>fault.title===top).map(fault=>fault.equipment_name))]
                            topAHuAnomalyDetail.push(detail)
                        }
                    }
                    me.topAHuAnomalyDetail=topAHuAnomalyDetail;
                    me.loading=false
                })
                getIssueSummary({
                    'facility_name': me.$store.state.pointsListStore.pointsList.facility_name,
                    'date_range': me.dateRange
                }).then(function(summaryResult){
                    let totalCost=summaryResult.summary.reduce((sum, x) => sum + x.cost, 0)
                    let mostExpensive=[...summaryResult.summary].sort(function(a,b){return b.cost-a.cost}).filter(x=>x.cost>0);
                    let longest=[...summaryResult.summary].sort(function(a,b){return b.value-a.value}).filter(x=>x.value>0);

                    me.topCost={
                        "data":[{
                            type: 'bar',
                            x: mostExpensive.map(x=>x.cost).reverse(),
                            y: mostExpensive.map(x=>x.issue).reverse(),
                            orientation: 'h',
                        }],
                        "layout":{
                            title:me.$options.filters.translate("Most Expensive Faults. Total Cost")+" : "+totalCost.toFixed(2)+" kWh",
                            autosize: true,
                            margin:{
                                l:550
                            },
                            xaxis:{},
                            yaxis:{},
                            height:Math.max(400,25*mostExpensive.length),
                        }
                    }
                    me.topDuration={
                        "data":[{
                            type: 'bar',
                            x: longest.map(x=>x.value*0.1).reverse(),
                            y: longest.map(x=>x.issue).reverse(),
                            orientation: 'h',
                        }],
                        "layout":{
                            title:me.$options.filters.translate("Faults With Highest Duration Of Occurrence (hr)"),
                            autosize: true,
                            margin:{
                                l:550
                            },
                            xaxis:{},
                            yaxis:{},
                            height:Math.max(400,25*longest.length),
                        }
                    }

                })


            }

        },
        async beforeMount() {
            let maxDate=this.$store.state.pointsListStore.pointsList.data_max_date;
            if(maxDate){
                this.baseDate=moment(maxDate).subtract(31, "days")
                this.endDate=moment(maxDate).subtract(1, "days")
                this.dateRange={start:this.baseDate.format('YYYY-MM-DD'),end:this.endDate.format('YYYY-MM-DD')}
            }
            let rulescall= await getRule({
                facility_name: this.$store.state.pointsListStore.pointsList.facility_name,
            })
            this.rules=rulescall.result

        },
        mounted(){
            this.getData();
        }



    }
</script>
